module.exports = __webpack_public_path__ + "static/media/seigneur2.09c2e6a9.jpg";